/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { Market } from 'src/config';
import copy from 'src/config/default/copy';
import asset from 'src/config/default/asset';
import featureFlags from 'src/config/default/featureFlags';
import memberInsurance from 'src/config/default/memberInsurance';
import nonMemberInsurance from 'src/config/default/nonMemberInsurance';

export const createDefaultMarket: Market = {
  marketId: 'US',
  copy,
  asset,
  featureFlags,
  memberInsurance,
  nonMemberInsurance
};
